// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--AIy-O";
export var bxTextTruncateEnd = "Accordion-module--bx--text-truncate--end--2XcVh";
export var bxTextTruncateFront = "Accordion-module--bx--text-truncate--front--x1o4k";